import React, { useState, useEffect } from "react";
import { Input } from "reactstrap";
import {
	isValidPostalZipCode,
	maxPostalCodeLength,
	normalizeCanadianPostalCode
} from "../../utilities/addressHelper";
import Countries from "../../constants/countries";

export default function PostalZipCodeControl({
	defaultValue = "",
	onChange = (event) => {},
	cssClass,
	style,
	disabled = false,
	placeholder = "Postal Code",
	required = false,
	id,
	name,
	region,
	...props
}) {
	const [maxLength, setMaxLength] = useState(maxPostalCodeLength(region));
	const [isValid, setIsValid] = useState(false);
	const normalizeZipCode = {
		[Countries.USA]: (zip) => zip?.toString().trim().toUpperCase() ?? "",
		[Countries.Canada]: normalizeCanadianPostalCode,
		[Countries.Unknown]: (v) => v?.toString().trim() ?? "",
	};

	useEffect(() => {
		setMaxLength(maxPostalCodeLength(region));
		setIsValid(isValidPostalZipCode(defaultValue, region));
	}, [region]);

	function handleChange(event) {
		const newValue = event.target.value;
		const newValidity = isValidPostalZipCode(newValue, region);
		if (newValidity) {
			event.target.value = normalizeZipCode[region](newValue);
		}
		setIsValid(newValidity);
		onChange(event, newValidity);
	}

	return (
		<Input
			type="text"
			id={id}
			name={name}
			className={cssClass}
			style={style}
			disabled={disabled}
			defaultValue={defaultValue}
			placeholder={placeholder}
			onChange={handleChange}
			required={required}
			autoComplete="postal-code"
			maxLength={maxLength}
			valid={isValid}
			invalid={!isValid}
			{...props}
		/>
	);
}
